import { gql } from '@apollo/client';

const queryGetOrderDetails = gql`
  query orderDetailQuery($pk: Int!) @api(name: root) {
    order(pk: $pk) {
      id
      reference
      subject
      contactEmail
      createdAt
      pdfUrl
      currency
      customer {
        title
        address1
      }
      supplier {
        title
        address1
        vatNumber
      }
      lines {
        id
        description
        unitPrice
        quantity
        total
        unitType
        service {
          title
        }
      }
      invoices {
        id
        reference
      }
    }
  }
`;

export default queryGetOrderDetails;
